/**
 * Created by Daniel on 11/1/2022
 * ------ maintenance history ------
 */

import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { DialogAction, DialogService, DialogType } from '../../services/dialog.service';
import { ContactViewModel } from '../../tamalelibs/components/contact.view-model';
import { EntityService } from '../../tamalelibs/services/entity.service';
import { EntityViewModelForWeb } from '../entity-dialog/entity-view-web.model';
import { DashboardTileService } from '../tam-dashboard/dashboard-tile.service';
import { MapContactModel } from '../tam-dashboard/tam-dashboard-map-tile/tam-dashboard-map-autocomplete/tam-dashboard-map-autocomplete.model';
import { TamDashboardMapTileConfiguration, TamDashboardTileData } from '../tam-dashboard/tam-dashboard-map-tile/tam-dashboard-map-tile.config';
import { MapConfig } from '../tam-dashboard/tam-dashboard-map-tile/tam-dashboard-map/tam-dashboard-map.model';


@Component({
    selector: 'tam-map-tile-dialog',
    templateUrl: './map-tile-dialog.component.html',
    styleUrls: ['./map-tile-dialog.component.scss']
})
export class MapTileDialogComponent implements OnInit, OnDestroy {
    // #region public properties
    configMapTile: TamDashboardMapTileConfiguration;
    dialogWidth = '90%';
    mapConfig = new MapConfig();
    mapContactModel = new MapContactModel();
    isOpen = false;
    isFromShowEventOnMapTile = true;
    // #endregio

    // #region private properites
    private _destroySubscriptions: Array<Subscription> = [];
    // #endregion

    // #region constructor
    constructor(
        private _changeDetectorRef?: ChangeDetectorRef,
        private _contactViewModel?: ContactViewModel,
        private _dashboardTileService?: DashboardTileService,
        private _dialogService?: DialogService,
        private _entityService?: EntityService,
        private _entityViewModel?: EntityViewModelForWeb,
    ) { }
    // #endregion

    // #region ngOnInit
    ngOnInit() {
        this._initMapTileComponent();
        this._destroySubscriptions.push(
            this._dialogService.dialogOpen$.pipe(
                filter(item => item.type === DialogType.MapTileDialog),
            ).subscribe((action) => this._dialogOpenHandler(action)),

            this._dialogService.dialogClose$.pipe(
                filter(item => item.type === DialogType.MapTileDialog),
            ).subscribe(() => this._dialogCloseHandler())
        );
    }
    // #endregion

    // #region ngOnDestroy
    ngOnDestroy() {
        this._destroySubscriptions.forEach(element => element.unsubscribe());
    }
    // #endregion

    // #region public functions
    onCancelClick() {
        const dialogAction = new DialogAction(DialogType.MapTileDialog);
        this._dialogService.dialogClose$.next(dialogAction);
    }
    // #endregion

    // #region private functions
    /**
     * close map tile dialog
     */
    private _dialogCloseHandler() {
        this.isOpen = false;
        this._changeDetectorRef.detectChanges();
    }

    /**
     * @param param open map tile dialog
     */
    private _dialogOpenHandler(action) {
        this.isOpen = true;
        this.mapContactModel = action.payload;
        if (!action.payload.latitude || !action.payload.longitude) {
            this._dashboardTileService.getMapSearchGeocodeAddress(action.payload.selectedAddress)
                .pipe(take(1))
                .subscribe(location => {
                    const mapTileData = new TamDashboardTileData(location.lat, location.lng, action.payload.entityId, action.payload.entityName, action.payload.entityType, '', action.payload.selectedAddress, action.payload.addressType, action.payload.eventProperties, action.payload.threadId);
                    this.mapConfig.markerArray = [];
                    this.mapConfig.markerArray.push(mapTileData);
                    this.configMapTile.data = [];
                    this.configMapTile.data.push(mapTileData);
                    this._changeDetectorRef.detectChanges();
                });
        } else {
            const mapTileData = new TamDashboardTileData(action.payload.latitude, action.payload.longitude, action.payload.entityId, action.payload.entityName, action.payload.entityType, '', action.payload.selectedAddress, action.payload.addressType, action.payload.eventProperties, action.payload.threadId);
            this.mapConfig.markerArray = [];
            this.mapConfig.markerArray.push(mapTileData);
            this.configMapTile.data = [];
            this.configMapTile.data.push(mapTileData);
            this._changeDetectorRef.detectChanges();
        }
    }

    private _initMapTileComponent() {
        const actionSubject$ = new Subject();
        const feedbackSubject$ = new Subject();

        this.configMapTile = new TamDashboardMapTileConfiguration(null, this._dashboardTileService, this._contactViewModel, this._entityService, this._entityViewModel);
        this.configMapTile.init('showEventInMapTile', false, 'map', actionSubject$, feedbackSubject$);
    }
    // #endregion
}
